import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Route, RefreshCw } from "lucide-react";

export const RoutingLog = () => {
  const [rows, setRows] = useState([]);
  const load = () => { api.get("/admin/live-transfers/routing-log").then((r) => setRows(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);

  return (
    <Card className="mb-5 p-6" data-testid="routing-log-card">
      <div className="mb-3 flex items-start justify-between gap-4">
        <div>
          <h3 className="flex items-center gap-2 font-display font-bold text-slate-900"><Route className="h-4 w-4" /> Why each call went where it did</h3>
          <p className="text-xs text-slate-500">For the last 10 calls to the live line: who got the call, and why each MLO in line was or wasn't rung.</p>
        </div>
        <Button variant="outline" size="sm" onClick={load} data-testid="routing-log-refresh"><RefreshCw className="h-4 w-4" /></Button>
      </div>
      {!rows.length && <p className="text-sm text-slate-500" data-testid="routing-log-empty">No calls logged yet. Make a test call to 407-698-3461.</p>}
      {rows.map((r, i) => (
        <div key={r.at} className="border-t border-slate-100 py-3 text-sm" data-testid={`routing-log-row-${i}`}>
          <div className="font-semibold text-slate-800">{new Date(r.at).toLocaleString()} · caller …{r.caller_last4}</div>
          <div className="mb-1 text-slate-700">{r.result}</div>
          <ul className="space-y-0.5 text-xs">
            {r.mlos.map((m) => (
              <li key={m.name + m.phone_last4} className={m.reason === "Eligible" ? "text-emerald-700" : "text-slate-500"}>
                {m.name} (…{m.phone_last4 || "none"}): {m.reason}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </Card>
  );
};
